import React from "react";
import { COMPANY } from "../config/company";
import { useLang } from "../contexts/LanguageContext";

export default function Impressum() {
  const { lang } = useLang();
  const t = (k) => ({
    title: { de: "Impressum", en: "Legal Notice", tr: "Künye" },
    intro: { de: "Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)", en: "Information according to § 5 DDG (German Digital Services Act)", tr: "§ 5 DDG (Alman Dijital Hizmetler Yasası) uyarınca bilgiler" },
    rep: { de: "Vertreten durch den Geschäftsführer", en: "Represented by the Managing Director", tr: "Yönetici tarafından temsil edilir" },
    contact: { de: "Kontakt", en: "Contact", tr: "İletişim" },
    register: { de: "Registereintrag", en: "Register Entry", tr: "Sicil Kaydı" },
    court: { de: "Registergericht", en: "Register Court", tr: "Sicil Mahkemesi" },
    regnum: { de: "Registernummer", en: "Register Number", tr: "Sicil Numarası" },
    tax: { de: "Steuer", en: "Tax", tr: "Vergi" },
    taxnum: { de: "Steuernummer", en: "Tax Number", tr: "Vergi Numarası" },
    vat: { de: "Umsatzsteuer-ID gemäß § 27a UStG", en: "VAT ID according to § 27a UStG", tr: "§ 27a UStG'ye göre KDV Kimlik No" },
    contentResp: { de: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV", en: "Responsible for content according to § 18 (2) MStV", tr: "§ 18 (2) MStV'ye göre içerikten sorumlu" },
    disclaimer: { de: "Haftungsausschluss", en: "Disclaimer", tr: "Sorumluluk Reddi" },
    disclaimerContent: {
      de: "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.",
      en: "Despite careful content control, we assume no liability for the content of external links. The operators of the linked pages are solely responsible for their content.",
      tr: "Dikkatli içerik kontrolüne rağmen, harici bağlantıların içeriği için sorumluluk kabul etmiyoruz. Bağlantılı sayfaların içeriğinden yalnızca bunların operatörleri sorumludur.",
    },
  })[k]?.[lang] || k;

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="impressum-page" style={{ marginTop: "-4rem", paddingTop: "4rem" }}>
      <div className="container mx-auto px-6 lg:px-12 py-16 max-w-3xl">
        <h1 className="text-4xl font-bold tracking-tight mb-2">{t("title")}</h1>
        <p className="text-sm text-muted-foreground mb-10">{t("intro")}</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <div className="font-semibold mb-1">{COMPANY.legalName}</div>
            <div>{COMPANY.street}</div>
            <div>{COMPANY.zip} {COMPANY.city}</div>
            <div>{COMPANY.country}</div>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">{t("rep")}</h2>
            <div>{COMPANY.managingDirector}</div>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">{t("contact")}</h2>
            <div>E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-purple-600 dark:text-purple-400 hover:underline">{COMPANY.email}</a></div>
            {COMPANY.phone && <div>Tel: {COMPANY.phone}</div>}
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">{t("register")}</h2>
            <div>{t("court")}: {COMPANY.registerCourt}</div>
            <div>{t("regnum")}: {COMPANY.registerNumber}</div>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">{t("tax")}</h2>
            <div>{t("taxnum")}: {COMPANY.taxNumber}</div>
            {COMPANY.vatId && <div>{t("vat")}: {COMPANY.vatId}</div>}
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">{t("contentResp")}</h2>
            <div>{COMPANY.managingDirector}</div>
            <div>{COMPANY.street}, {COMPANY.zip} {COMPANY.city}</div>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">{t("disclaimer")}</h2>
            <p className="text-muted-foreground">{t("disclaimerContent")}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
